// src/utils/apiBase.js
// Acepta relativo (/api) o absoluto (http://localhost:4001/api)
const raw = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4001/api';
const clean = String(raw).replace(/\/+$/, '');
export const API = clean.endsWith('/api') ? clean : `${clean}/api`;
